var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12",staticStyle:{"padding-bottom":".4em"}},_vm._l((_vm.messages),function(msg,i){return _c('li',{key:i},[_vm._v(" "+_vm._s(msg)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }